export enum Status {
    // Deleted = -1,
    Disabled = 0,
    Active = 1
}

(Status as any).__typeName = 'Status';
